import { filterOptions } from '@/utils/query-base'
import { formatSapDate } from '@/mixins/index'
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'ZZFLD000002': {
    title: '省份',
    type: 'select',
    equation: city,
    dictionary: 'region'
  },
  'ZZFLD000003': {
    title: '城市',
    type: 'select',
    equation: city,
    dictionary: 'city'
  },
  'ZZFLD000001': {
    title: '营销单元',
    type: 'select',
    equation: city,
    dictionary: 'sale'
  },
  'ZZFLD00003E': {
    title: '基地',
    type: 'select',
    equation: city,
    dictionary: 'base'
  },
  'ZZFLD000004': {
    title: '业务员',
    equation: all,
    type: 'input'
  },
  'CUSTOMER': {
    title: '客户编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编码'
    }
  },
  'CUSTOMER_TYPE': {
    title: '客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'OBJECT_ID': {
    title: '销售订单编号',
    type: 'input',
    equation: all
  },
  'PROCESS_TYPE': {
    title: '销售订单类型',
    type: 'select',
    equation: city,
    dictionary: 'A0043'
  },
  'ZZFLD00002D': {
    title: '创建账号',
    type: 'input',
    equation: all
  },
  'NAME_FIRST': {
    title: '创建人名称',
    type: 'input',
    equation: all
  },
  'POSTING_DATE': {
    title: '创建日期',
    type: 'date',
    equation: all,
    defaultVal: new Date()
  },
  'ZZFLD00002Q': {
    title: '计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0002'
  },
  'PRODUCT_ID': {
    title: '产品编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品编码'
    }
  }
}

export default {
  'object_id': { title: '销售订单号', slot: true },
  'process_type_text': { title: '销售订单类型' },
  'status_text': { title: '状态' },
  'customer': { title: '订单客户编码' },
  'cust_name': { title: '订单客户名称', width: 200 },
  'customer_type_text': { title: '订单客户类型' },
  'zzfld00001h_text': { title: '营销单元' },
  'zzfld00003e_text': { title: '基地' },
  'number_int': { title: '行号', formatter: ({ cellValue }) => Number(cellValue), xlsxFmt: { t: 'n' }},
  'zzfld00002q_text': { title: '计划类型', width: 180 },
  'ordered_prod': { title: '产品编码', width: 200 },
  'description': { title: '产品描述', width: 300 },
  'zzfld00002s': { title: '规格型号', width: 200 },
  'zzfld00002t': { title: '单位' },
  'quantity': { title: '数量', xlsxFmt: { t: 'n' }},
  'zzfld000009': { title: '件数', xlsxFmt: { t: 'n' }},
  'use_bot': { title: '瓶数', xlsxFmt: { t: 'n' }},
  'zzfld00002e': { title: '税率' },
  'net_price': { title: '含税单价', xlsxFmt: { t: 'n' }},
  'net_value': { title: '订单价税合计', xlsxFmt: { t: 'n' }},
  'zzfld00002a_text': { title: '折扣类型' },
  'zzfld00002f': { title: '单品折扣' },
  'zzfld00002g': { title: '折后含税单价', xlsxFmt: { t: 'n' }},
  'zzfld00002i': { title: '订单折扣额', xlsxFmt: { t: 'n' }},
  'zzfld00002o': { title: '占用开票数量', xlsxFmt: { t: 'n' }},
  'zzfld000035': { title: '已占用开票件数', width: 150, xlsxFmt: { t: 'n' }},
  'zy_bill_bot': { title: '已占用开票瓶数', width: 150, xlsxFmt: { t: 'n' }},
  'zzfld000007': { title: '累计开票数量', xlsxFmt: { t: 'n' }},
  'zzfld000032': { title: '累计开票件数', xlsxFmt: { t: 'n' }},
  'lj_bill_bot': { title: '累计开票瓶数', xlsxFmt: { t: 'n' }},
  'zzfld00002b': { title: '是否关闭' },
  'zzfld000008': { title: '备注', width: 200 },
  'all_price': { title: '整单价税合计', xlsxFmt: { t: 'n' }},
  'all_quantity': { title: '整单数量合计', xlsxFmt: { t: 'n' }},
  'all_bot': { title: '整单瓶数合计', xlsxFmt: { t: 'n' }},
  'posting_date': { title: '创建日期', formatter: ({ cellValue }) => formatSapDate(cellValue) },
  'zzfld00002d_dscr': { title: '创建人' }
}



// WEBPACK FOOTER //
// ./src/views/order-manage/config/orderWaitClose.js